import React, { useEffect, useState } from "react";
import Image from "next/image";
import { useQuery } from "@apollo/client";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import Skeleton from "react-loading-skeleton";

import { getAffariyetCheck, getSimilarStoresBySubCategory } from "gql/queries/stores.gql";
import {
  AffariyetEntity,
  AffariyetEntityResponseCollection,
  SimilarStoreEntityResponseCollection,
  StoreEntity,
} from "gql-types";

import { useGlobalState } from "context/GlobalStateContext";

import upArrow from "public/images/up-arrow.svg";
import SellerPageCard from "components/categories/products/SellerPageCard";
import { useParams } from "next/navigation";

function SimilarStores({ subCategory, store }: { subCategory: string; store: any }) {
  const params = useParams();
  const router = useRouter();
  const [category, setCategory] = useState<string>(params?.category as string);
  const { language } = useGlobalState(); // to remove
  const [similarStores, setSimilarStores] = useState<StoreEntity[]>([]);
  const [hideSection, setHideSection] = useState<boolean>(false);
  const { t: translate } = useTranslation("offers");
  const [affariyet, setAffariyet] = useState<AffariyetEntity[]>([]);

  const { data } = useQuery<{
    affariyets: AffariyetEntityResponseCollection;
  }>(getAffariyetCheck, {
    variables: {
      filters: {
        store: {
          sub_category: {
            category: {
              slug: { eq: category },
            },
          },
        },
      },
    },
    onCompleted: (data) => {
      setAffariyet(data.affariyets.data);
    },
  });

  const { loading } = useQuery<{ similarStores?: SimilarStoreEntityResponseCollection }>(
    getSimilarStoresBySubCategory,
    {
      skip: !subCategory,
      variables: {
        filters: {
          sub_category: {
            name: { eq: subCategory },
          },
        },
      },
      onCompleted: (data) => {
        setSimilarStores(data.similarStores?.data[0]?.attributes?.stores?.data ?? []);
      },
      onError: (err) => console.log("there is an err", err),
    },
  );

  function handleHidesection() {
    setHideSection((hideSection) => !hideSection);
  }
  function handleNavigation() {
    router.replace({
      pathname: `/categories/${category}`,
      query: {
        extraOptions: JSON.stringify({
          sub_category: {
            name: {
              containsi: subCategory,
            },
          },
        }),
      },
    });
  }
  // referesh the similar stores when the subCategory changes
  useEffect(() => {
    setSimilarStores([]);
  }, [subCategory]);

  if (similarStores.length <= 0) return;
  let similarStoreCategory;
  switch (category) {
    case "gastronomie":
      similarStoreCategory = translate("gastronomy");
      break;
    case "fete-et-mariage":
      similarStoreCategory = translate("partyWedding");
      break;
    case "loisir":
      similarStoreCategory = translate("adresse");
      break;
    default:
      similarStoreCategory = "Boutique";
      break;
  }

  return (
    <>
      {similarStores?.length > 0 && (
        <section
          className={`
       ${loading && similarStores.length < 1 && "hidden"}
       bg-white rounded-xl grid gap-10 py-10 lg:px-10 place-items-center`}
        >
          <h2 className="px-6 flex flex-row justify-between items-center  w-full">
            <span className="text-blue font-bold text-xl lg:text-2xl leading-6">
              {translate("similar_stores")} {store.name?.split("_").join(" ")}
            </span>
            <button
              type="button"
              onClick={handleHidesection}
              className="lg:flex lg:gap-3 lg:items-center"
            >
              <span className="hidden lg:block text-blue font-semibold text-2xl leading-6">
                {hideSection ? translate("show_more") : translate("show_less")}
              </span>
              <Image
                src={upArrow}
                alt="upArrow"
                width={15}
                height={15}
                className={`${hideSection && "rotate-180"}`}
              />
            </button>
          </h2>
          <div
            className="grid transition-all duration-500 overflow-hidden lg:px-32"
            style={{ gridTemplateRows: hideSection ? "0fr" : "1fr" }}
          >
            <div className=" flex  overflow-x-auto snap-x snap-mandatory gap-5 no-scrollbar lg:grid lg:snap-none lg:grid-cols-3 xl:grid-cols-4  ">
              {loading
                ? Array.from({ length: 3 }).map((_, index: number) => (
                    <div
                      key={`skeleton__${index}`}
                      className=" flex-shrink-0 lg:flex-auto snap-start "
                    >
                      <Skeleton containerClassName="w-80 h-90 pb-6" className="inline-block h-96" />
                    </div>
                  ))
                : similarStores.map((similarStore) => (
                    <div
                      key={`affariyet__${similarStore.id}`}
                      className=" flex-shrink-0 lg:flex-auto snap-start max-w-[250px] md:max-w-fit scroll-mx-16"
                    >
                      <SellerPageCard
                        storeData={similarStore}
                        category={category}
                        lang={language}
                        haveAffar={affariyet.some(
                          (affar: AffariyetEntity) =>
                            affar.attributes?.store?.data?.attributes?.slug ===
                            similarStore?.attributes?.slug,
                        )}
                      />
                    </div>
                  ))}
            </div>
          </div>
          <button
            disabled={!category}
            onClick={handleNavigation}
            className="hidden lg:block bg-blue text-white font-semibold text-xl leading-6 rounded-lg py-3 px-5 "
          >
            {translate("see_more")}
          </button>
        </section>
      )}
    </>
  );
}

export default SimilarStores;
